(() => {
  const initCollection = (root) => {
    const form = root.querySelector('#CodebrwnCollectionFilters');
    const grid = root.querySelector('.cb-collection-grid');
    const drawer = root.querySelector('#CodebrwnFilterDrawer');
    const sortDrawer = root.querySelector('#CodebrwnSortDrawer');
    const openDrawerButtons = Array.from(root.querySelectorAll('[data-cb-filter-drawer-open]'));
    const closeDrawerButton = root.querySelector('[data-cb-filter-drawer-close]');
    const openSortDrawerButton = root.querySelector('[data-cb-sort-drawer-open]');
    const closeSortDrawerButton = root.querySelector('[data-cb-sort-drawer-close]');
    const sortSelect = root.querySelector('[data-cb-sort]');
    const mobileSortOptions = Array.from(root.querySelectorAll('[data-cb-mobile-sort-option]'));
    const count = root.querySelector('[data-cb-count]');
    const pagination = root.querySelector('[data-cb-pagination]');
    const filterSelects = Array.from(form.querySelectorAll('select[data-cb-filter]'));
    const facetSelects = Array.from(form.querySelectorAll('select[data-cb-facet-select]'));
    const mobileClientFilters = Array.from(form.querySelectorAll('[data-cb-mobile-filter]'));
    let nextPageLink = root.querySelector('[data-cb-next-page]');
    let loading = false;
    let observer;

    if (!form || !grid) return;

    const products = () => Array.from(grid.querySelectorAll('[data-cb-product]'));

    const params = new URLSearchParams(window.location.search);
    const defaultNewestSaleLast = !params.has('sort_by') || params.get('sort_by') === 'created-descending';
    if (defaultNewestSaleLast && sortSelect) sortSelect.value = 'created-descending';
    const useNewestSaleLast = () => sortSelect ? sortSelect.value === 'created-descending' : defaultNewestSaleLast;
    if (defaultNewestSaleLast) {
      mobileSortOptions.forEach((option) => {
        const isActive = option.dataset.cbMobileSortOption === 'created-descending';
        option.classList.toggle('is-active', isActive);
        option.setAttribute('aria-pressed', String(isActive));
      });
    }

    filterSelects.forEach((select) => {
      const value = params.get(select.name);
      if (value) select.value = value;
    });

    const selectedDiscounts = () => Array.from(form.querySelectorAll('input[name="cb_discount"]:checked'))
      .map((input) => input.value);

    const selectedMobileFilterValues = (key) => mobileClientFilters
      .filter((input) => input.dataset.cbMobileFilter === key && input.checked)
      .map((input) => input.value);

    const productMatchesTopFilters = (item) => filterSelects.every((select) => {
      if (!select.value) return true;
      const key = select.dataset.cbFilter;
      const values = (item.dataset[`cb${key.charAt(0).toUpperCase()}${key.slice(1)}`] || '').split(' ');
      return values.includes(select.value);
    });

    const productMatchesMobileFilters = (item) => ['category', 'size', 'color'].every((key) => {
      const activeValues = selectedMobileFilterValues(key);
      if (!activeValues.length) return true;
      const values = (item.dataset[`cb${key.charAt(0).toUpperCase()}${key.slice(1)}`] || '').split(' ');
      return activeValues.some((value) => values.includes(value));
    });

    const productMatchesDiscount = (item) => {
      const values = selectedDiscounts();
      if (!values.length) return true;
      const discount = Number(item.dataset.cbDiscount || 0);
      return values.some((value) => {
        if (value === 'sale') return discount > 0;
        return discount >= Number(value);
      });
    };

    const applyClientFilters = () => {
      let visible = 0;

      products().forEach((item) => {
        const shouldShow = productMatchesTopFilters(item) && productMatchesMobileFilters(item) && productMatchesDiscount(item);
        item.classList.toggle('is-hidden', !shouldShow);
        if (shouldShow) visible += 1;
      });

      if (count) count.textContent = `${visible} ${visible === 1 ? 'item' : 'items'}`;
    };

    const applyDiscountSort = () => {
      if (useNewestSaleLast()) {
        products().sort((a, b) => {
          const saleOrder = Number(Number(a.dataset.cbDiscount) > 0) - Number(Number(b.dataset.cbDiscount) > 0);
          return saleOrder || Number(b.dataset.cbCreated) - Number(a.dataset.cbCreated);
        }).forEach((item) => grid.appendChild(item));
        return;
      }
      if (!sortSelect || sortSelect.value !== 'discount-desc') return;

      products()
        .sort((a, b) => Number(b.dataset.cbDiscount || 0) - Number(a.dataset.cbDiscount || 0))
        .forEach((item) => grid.appendChild(item));
    };

    const updateUrlForClientControls = () => {
      const params = new URLSearchParams(window.location.search);
      ['cb_category', 'cb_size', 'cb_color'].forEach((name) => params.delete(name));
      filterSelects.forEach((select) => {
        if (select.value) {
          params.append(select.name, select.value);
        }
      });
      mobileClientFilters
        .filter((input) => input.checked)
        .forEach((input) => params.append(input.name, input.value));
      params.delete('cb_discount');
      selectedDiscounts().forEach((value) => params.append('cb_discount', value));

      if (sortSelect && sortSelect.value === 'discount-desc') {
        params.set('sort_by', 'discount-desc');
      }

      params.delete('page');
      const query = params.toString();
      window.history.replaceState({}, '', `${window.location.pathname}${query ? `?${query}` : ''}`);
    };

    const setNextLink = (doc) => {
      const incoming = doc.querySelector('[data-codebrwn-collection] [data-cb-next-page]');
      if (incoming) {
        nextPageLink = incoming;
        if (pagination) {
          pagination.hidden = false;
          pagination.innerHTML = '';
          pagination.appendChild(nextPageLink);
        }
      } else {
        nextPageLink = null;
        if (pagination) pagination.hidden = true;
        if (observer) observer.disconnect();
      }
    };

    const loadNextPage = async () => {
      if (loading || !nextPageLink) return;
      loading = true;
      const href = nextPageLink.href;

      try {
        const response = await fetch(href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error(`Collection request failed: ${response.status}`);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const incomingItems = Array.from(doc.querySelectorAll('[data-codebrwn-collection] .cb-collection-grid [data-cb-product]'));

        incomingItems.forEach((item) => {
          item.querySelectorAll('img').forEach((image) => { image.loading = 'lazy'; });
          grid.appendChild(item);
        });
        setNextLink(doc);
        applyDiscountSort();
        applyClientFilters();
        return true;
      } catch (error) {
        if (pagination) pagination.hidden = false;
        if (observer) observer.disconnect();
        return false;
      } finally {
        loading = false;
      }
    };

    const closeDialog = (dialog) => {
      if (dialog?.open) dialog.close();
    };

    openDrawerButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (drawer && typeof drawer.showModal === 'function') {
          drawer.showModal();
        }
      });
    });

    closeDrawerButton?.addEventListener('click', () => {
      closeDialog(drawer);
    });

    drawer?.addEventListener('click', (event) => {
      if (event.target === drawer) closeDialog(drawer);
    });

    openSortDrawerButton?.addEventListener('click', () => {
      if (sortDrawer && typeof sortDrawer.showModal === 'function') {
        sortDrawer.showModal();
      }
    });

    closeSortDrawerButton?.addEventListener('click', () => {
      closeDialog(sortDrawer);
    });

    sortDrawer?.addEventListener('click', (event) => {
      if (event.target === sortDrawer) closeDialog(sortDrawer);
    });

    form.addEventListener('change', (event) => {
      const changedControl = event.target;

      if (changedControl?.matches('input[type="checkbox"]')) {
        const pairedSelect = facetSelects.find((select) => select.dataset.cbFacetSelect === changedControl.name);
        if (pairedSelect) {
          pairedSelect.value = '';
          pairedSelect.removeAttribute('name');
        }
      }

      if (changedControl?.matches('select[data-cb-facet-select]')) {
        const paramName = changedControl.dataset.cbFacetSelect;
        changedControl.name = paramName;
        form.querySelectorAll('.cb-filter-group input[type="checkbox"]').forEach((input) => {
          if (input.name === paramName) input.checked = false;
        });
        form.submit();
        return;
      }

      if (event.target?.name === 'cb_discount' || event.target?.matches('select[data-cb-filter], [data-cb-mobile-filter]')) {
        updateUrlForClientControls();
        applyClientFilters();
      }
    });

    sortSelect?.addEventListener('change', () => {
      if (sortSelect.value === 'discount-desc') {
        updateUrlForClientControls();
        applyDiscountSort();
        applyClientFilters();
      } else {
        form.submit();
      }
    });

    mobileSortOptions.forEach((button) => {
      button.addEventListener('click', () => {
        if (!sortSelect) return;
        sortSelect.value = button.dataset.cbMobileSortOption;

        mobileSortOptions.forEach((option) => {
          const isActive = option === button;
          option.classList.toggle('is-active', isActive);
          option.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        if (sortSelect.value === 'discount-desc') {
          updateUrlForClientControls();
          applyDiscountSort();
          applyClientFilters();
          closeDialog(sortDrawer);
        } else {
          form.submit();
        }
      });
    });

    if (!useNewestSaleLast() && pagination && nextPageLink && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) loadNextPage();
      }, { rootMargin: '600px 0px' });
      observer.observe(pagination);
    }

    const prepareDefaultOrder = async () => {
      grid.setAttribute('aria-busy', 'true');
      root.classList.add('is-sorting');
      try {
        if (Number(params.get('page')) > 1) {
          const firstPage = new URL(window.location.href);
          firstPage.searchParams.delete('page');
          const response = await fetch(firstPage, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          if (!response.ok) throw new Error(`Collection request failed: ${response.status}`);
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const incoming = doc.querySelector('[data-codebrwn-collection] .cb-collection-grid');
          if (!incoming) throw new Error('Collection grid missing');
          grid.replaceChildren(...incoming.children);
          setNextLink(doc);
        }
        while (nextPageLink) {
          if (!await loadNextPage()) break;
        }
        applyDiscountSort();
        applyClientFilters();
      } catch {
        if (pagination) pagination.hidden = !nextPageLink;
      } finally {
        root.classList.remove('is-sorting');
        grid.removeAttribute('aria-busy');
      }
    };
    if (useNewestSaleLast()) prepareDefaultOrder();
    else {
      applyDiscountSort();
      applyClientFilters();
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-codebrwn-collection]').forEach(initCollection);
  });
})();
